export default function createDomElement<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props?: Record<string, any>,
  children?: Array<Node | string>
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  if (props) {
    for (const [key, value] of Object.entries(props)) {
      if (key === "style" && value && typeof value === "object") {
        Object.assign((el as HTMLElement).style, value);
      } else if (key in el) {
        (el as any)[key] = value;
      } else if (value !== undefined) {
        el.setAttribute(key, String(value));
      }
    }
  }
  if (children) {
    for (const child of children) {
      if (typeof child === "string") {
        el.appendChild(document.createTextNode(child));
      } else {
        el.appendChild(child);
      }
    }
  }
  return el;
}
